export function generateDataURI(content, type) {
    switch (type) {
        case 'txt': {
            return 'data:text/plain;charset=utf-8,' + encodeURIComponent(content);
        }
        case 'json': {
            return 'data:application/json;charset=utf-8,' + encodeURIComponent(content);
        }
        case 'csv': {
            return 'data:text/csv;charset=utf-8,\uFEFF' + encodeURIComponent(content);
        }
        case 'xls': {
            return 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(content);
        }
        case 'xml': {
            return 'data:application/xml;charset=utf-8,' + encodeURIComponent(content);
        }
        default: {
            return '';
        }
    }
}
export function downloadFile(content, type, fileName) {
    if (fileName === void 0) { fileName = 'download'; }
    var dataURI = generateDataURI(content, type);
    var anchor = document.createElement('a');
    anchor.href = dataURI;
    anchor.download = fileName;
    anchor.setAttribute('style', 'visibility:hidden');
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}
